import TemplateCardSkeleton from "./TemplateCardSkeleton";

const TemplatesSkeleton: React.FC = () => {
  return (
    <div className="px-8 pb-3 min-h-screen">
      {/* Top section */}
      <div className="flex justify-between items-center mb-4 mt-4 min-h-[2.75rem] px-4">
        <div>
          <div
            data-testid="skeleton-block"
            className="w-40 h-5 bg-gray-200 rounded mb-1 animate-pulse"
          />
          <div
            data-testid="skeleton-block"
            className="w-60 h-4 bg-gray-200 rounded animate-pulse"
          />
        </div>
        <div
          data-testid="skeleton-block"
          className="w-[6.7rem] 2xl:w-[7.5rem] h-10 bg-gray-300 rounded-lg animate-pulse"
        />
      </div>

      <div className="flex mt-12 mb-4 justify-between px-4">
        <div className="flex space-x-6">
          <div
            data-testid="skeleton-block"
            className="w-24 h-6 bg-gray-300 rounded animate-pulse"
          />
          <div
            data-testid="skeleton-block"
            className="w-20 h-6 bg-gray-200 rounded animate-pulse"
          />
        </div>
        <div
          data-testid="skeleton-block"
          className="w-24 h-8 bg-gray-200 rounded animate-pulse"
        />
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {Array.from({ length: 6 }).map((_, idx) => (
          <TemplateCardSkeleton key={idx} />
        ))}
      </div>
    </div>
  );
};

export default TemplatesSkeleton;
